<template>
  <transition name="sukima-modal">
    <div class="sukima-modal__mask" @click.self="closeModal">
      <div class="sukima-modal__container">
        <!--        <div class="sukima-modal__logo">-->
        <!--          <slot name="icon"/>-->
        <!--        </div>-->
        <div class="sukima-modal__header">
          <slot name="header"/>
        </div>
        <div class="sukima-modal__body">
          <slot name="body"/>
        </div>
        <div class="sukima-modal__footer">
          <slot name="footer"/>
        </div>
        <div class="sukima-modal__extra">
          <slot name="extra" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
  },
  mounted() {
    // ga send event error handle
    if (typeof sendEvent === 'undefined') {
      window.sendEvent = function (arg1, arg2, arg3) {
        Raven.captureBreadcrumb({
          message: 'sendEvent undefined',
          category: 'warning',
          data: {
            file: 'sukima-book-viewer.js',
            arg1: arg1,
            arg2: arg2,
            arg3: arg3
          }
        });
      }
    }
    if (typeof sendEventDetail === 'undefined') {
      window.sendEventDetail = function (arg) {
        Raven.captureBreadcrumb({
          message: 'sendEventDetail undefined',
          category: 'warning',
          data: {
            file: 'sukima-book-viewer.js',
            arg: arg
          }
        });
      }
    }
  },
};
</script>
